

import React , {useState , useEffect} from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import {  getCourierOrderReports ,getCourierOrderExcelReports  } from '../../api/login/Login'

import CustomInputField from '../../common/CustomInputField'
import { Formik, Form, Field } from 'formik';
import { ToastContainer } from 'react-toastify'
import { message, Pagination ,Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Loadar from '../../common/loader/Loader'
import * as XLSX from 'xlsx'; 


const breadCrumbsTitle = {
    id: "1",
    title_1: 'Reports',
    title_2:  'Courier Reports',
  }


const CourierReport = ( ) => {
    // const [operators, setOperators] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
      const [data, setData] = useState(null);
      const [loading , setLoading] = useState(false)
    const [formKey, setFormKey] = useState(0);
    const [resetKey , setResetKey] = useState(false)

    const statusObj = [
        {
            label :'New',
            value:"New"
        },
    {
        label :'Ready To Ship',
        value :'Ready To Ship'
    },

{
    label :'Failed',
    value :'Failed'
},
{
    label :'Canceled',
    value :'Canceled'
},
]
    const defaultInitialValues = {
       
        start_date: '',
        end_date: '',
        order_id :'',
        status:'',
       
    };
    const resetValues = {
        start_date: '',
        end_date: '',
        order_id :'',
        status:'',
    };
    const [initialValues, setInitialValues] = useState(defaultInitialValues);

        const handleReset = (resetForm) => {
            resetForm();
            setInitialValues(resetValues);
            setFormKey(prev => prev + 1); 
            setCurrentPage(1)
            setResetKey((pre)=>!pre)
        };

        const handleSubmit = (values) => {
          
            setCurrentPage(1)
            setInitialValues(values)
            setResetKey((pre)=>!pre)

        };

        const onChangeVal = (page) => {
            setResetKey((pre)=>!pre)
            setCurrentPage(page);
           
        };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getCourierOrderReports({ 
        ...initialValues, 
        page: currentPage-1, 
        count:10,
      });
      if (res?.statusCode === 200) {
        setData(res);
      } else {
        setData(null);
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      message.error('Failed to fetch transaction data. Please try again.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };


    const downloadExcel = async () => {
      try {
        setLoading(true);
        const res = await getCourierOrderExcelReports(initialValues);
  
        if (res && res.data.length > 0) {
           

              const dataForExcel = res?.data?.map((order, index) => {
                const items = order.order_items
                  .map((item, i) => {
                    return `${i + 1}. ${item.name}\nSKU: ${item.sku}, Units: ${item.units}, Price: ₹${item.selling_price}, Tax: ${item.tax}%`;
                  })
                  .join('\n\n');
              
                return {
                  "Sr No": (index + 1),
                  "Date / Time": new Date(order.createdAt).toLocaleString(),
                  "Order ID": order.order_id,
                  "Order Status": order.orderStatus,
                  "Payment Mode": order.paymentMode,
                  "Shipping Mode": order.mode,
                  "Amount": `₹${order.amount || 0}`,
                  "PlateForm Charges": `₹${order.plateformCharge || 0}`,
                  "Final Amount": `₹${order.finalAmount || 0}`,
                  "Way Bill Number": `${order.waybill || 'N/A'}`,
                
                  "Weight": `${order.weight} kg`,
                  "Dimensions (LxWxH)": `${order.length}x${order.width}x${order.height} cm`,
                  "Seller Name": order.user?.name || "",
                  "Seller Email": order.user?.email || "",
                  "Customer Name": order.shipping_address?.shipping_customer_name || "",
                  "Customer Phone": order.shipping_address?.shipping_phone || "",
                  "Shipping Address": `${order.shipping_address?.shipping_address}, ${order.shipping_address?.shipping_city}, ${order.shipping_address?.shipping_state} - ${order.shipping_address?.shipping_pincode}`,
                  "Invoice": order.invoice_url || "Invoice not Generated",
                  "Order Items": items
                };
              });
                  
  
          const ws = XLSX.utils.json_to_sheet(dataForExcel);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, " Report");
          XLSX.writeFile(wb, `Report ${new Date().toLocaleDateString()}.xlsx`);
        } else {
          message.error('No data available to export!');
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        message.error('Failed to download Excel. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    


  useEffect(()=>{
    getData()
  },[resetKey , currentPage])
  return (
    <>
    { loading && <Loadar/> }
      <ToastContainer />

    
    <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
    
    {/* // Filter Option // */}
    <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} Search</b></h4>
                            </div>
                            <Formik
                                  key={formKey}
                                  initialValues={initialValues}
                                  onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ errors, touched, resetForm }) => (
                                    <Form className="tbl-captionn">
                                        <div className="row">
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="start_date"
                                                    placeholder="Start Date"
                                                    hasError={touched.start_date && errors.start_date}
                                                    errorMsg={errors.start_date}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="end_date"
                                                    placeholder="End Date"
                                                    hasError={touched.end_date && errors.end_date}
                                                    errorMsg={errors.end_date}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field as="select" className="form-select" name="status">
                                                    <option value="">Select Status</option>
                                                    {statusObj?.map((op) => (
                                                        <option key={op.value} value={op.value}>
                                                            {op.label}
                                                        </option>
                                                    ))}
                                                </Field>
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="order_id"
                                                    placeholder="Order Id"
                                                    hasError={touched.order_id && errors.order_id}
                                                    errorMsg={errors.order_id}
                                                />
                                            </div>
                                           
                                           
                                           
                                            <div className="col-lg-12 col-md-12">
                                                <div className="d-flex justify-content-start">
                                                    <button className="btn btn-primary me-2" type="submit">
                                                        <i className="fas fa-search"></i> Search
                                                    </button>
                                                    <btn className="btn btn-secondary" type="button" onClick={() => handleReset(resetForm)}>
                                                        <i className="fas fa-refresh"></i> Reset
                                                    </btn>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/* // filter option end here  */}


    {/* // table section  */}
    {data?.data?.length > 0 ? (
        <>
         <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                               <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{data?.totalAmount || 0}</b></h3>
                                </div>
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} List</b></h4>
                                        <div className='d-flex'>
                                           
                                            <button onClick={downloadExcel} className='btn btn-primary border border-white'> <DownloadOutlined /> Download Excel</button>
                                        </div>
                                      

                                    </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer"> 
   <table id="superadmin-order-table" className="table dataTable no-footer">
  <thead>
    <tr>
      <th>Sr. No</th>
      <th>Created Date</th>
      <th>Order ID</th>
      <th>Order Status</th>
      <th>Payment Mode</th>
      {/* <th>Payment Status</th> */}
      <th>Shipping Mode</th>
      {/* <th>Shipping Charges</th>
      <th>Gift Wrap</th>
      <th>Transaction Charges</th> */}
      {/* <th>Total Discount</th> */}
      <th>Amount</th>
      <th>Plateform Charges</th>
      <th>Total Charges</th>
      <th>Courier Name</th>
      <th>Way Bill</th>
      {/* <th>Net Value</th> */}
      <th>Weight</th>
      <th>Dimensions (L×W×H)</th>
      <th>Seller Name</th>
      <th>Seller Email</th>
      <th>Buyer</th>
      <th>Buyer Phone</th>
      
      <th>Buyer Address</th>
      {/* <th>Reseller</th> */}
     
      <th>Invoice</th>
      <th>Items</th>
    </tr>
  </thead>
  <tbody>
    {data?.data?.map((order , index)=>
     <tr key={index}>
     <td>{(index +1 ) + ((currentPage-1)*10)}</td>
     <td>{new Date(order.createdAt).toLocaleString()}</td>
     <td>{order?.order_id}</td>
     <td><span className={''}>{order.orderStatus}</span></td>
     <td>{order.paymentMode}</td>
     <td>{order.mode}</td>
     <td>₹{order.amount || 0 }</td>
     <td>₹{order.plateformCharge || 0 }</td>
     <td>₹{order.finalAmount || 0 }</td>
     <td>{order.courier_name || 'N/A'}</td>
     <td>{order?.waybill || 'N/A'}</td>
     <td>{order.weight} kg</td>
     <td>{order.length}x{order.width}x{order.height} cm</td>
     <td>{order.user?.name}</td>
     <td>{order.user?.email}</td>
     <td>{order.shipping_address?.shipping_customer_name}</td>
     <td>{order.shipping_address?.shipping_phone}</td>
    
     <td>
       {order.shipping_address?.shipping_address}<br />
       {order.shipping_address?.shipping_city}, {order.shipping_address?.shipping_state} - {order.shipping_address?.shipping_pincode}
     </td>
   
    
     <td>
        {order?.invoice_url ? 
       <a href={order.invoice_url} target="_blank" rel="noopener noreferrer">
         View Invoice
       </a>: 'Invoice not Generated' }
     </td>
     <td>
       <ul style={{ paddingLeft: 20 }}>
         {order.order_items.map((item, index) => (
           <li key={item._id}>
             <strong>{index + 1}. {item.name}</strong><br />
             SKU: {item.sku}, Units: {item.units}, Price: ₹{item.selling_price}, Tax: {item.tax}%
           </li>
         ))}
       </ul>
     </td>
   </tr>
    )}
   
  </tbody>
</table>

</div>

                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                        Total {data?.totalCount[0]?.count} entries
                                    </div>
                                    <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                        <Pagination
                                            /* showSizeChanger
                                            onShowSizeChange={''} */

                                            // defaultCurrent={1}
                                            // onChange={onChangeVal}
                                            total={data?.totalCount[0]?.count}
                                            current={currentPage}
                                            onChange={onChangeVal}
 
                                        />
                                    </div>
                                </div>
                            </div>
                           
                        </div>

                    </div>

                </div >
            </section>
        </>
        ) : (
          <div className="text-center mt-4">
            <h3>No data available</h3>
          </div>
        )}
       {/* // table section  */}
    </>
  )
}

export default CourierReport




